export default "__VITE_ASSET__D23Gh_LL__"